module.exports = __webpack_public_path__ + "static/media/294518.4d4ae4cf.png";